<div class="overlay" style="background-color: #f0f8ff52; z-index: 9999;" [hidden]="!visible">
  <!-- <img class="spinner" src="assets/img/logo/06-Logo.gif" /> -->
  <kendo-loader class="spinner" [type]="'infinite-spinner'" [themeColor]="'Dark'" [size]="'large'"></kendo-loader>
</div>
